import React from "react";
import { Button } from "../../components";
import store from "../../store";
import { clearCache } from "../../store/quote/action";

export const QuoteNotice = () => {
    const handleBackToHome = () => {
        store.dispatch(clearCache());
        window.location.href = "/";
    };

    return (
        <div className="container quote-notice-container">
            <div className="row">
                <div className="col-sm-12 col-md-12">
                    <div className="quote-notice-content">
                        <h2 className="page-header-center quote-notice-title">
                            We're unable to complete your quote online.
                        </h2>

                        <div className="quote-notice-text">
                            To finish your quote, please call us at
                        </div>

                        <div className="quote-notice-phone-wrapper">
                            <a 
                                href="tel:8665099444" 
                                className="quote-notice-phone-link"
                            >
                                (866) 509-9444
                            </a>
                        </div>

                        <div className="quote-notice-text">
                            Our agents are ready to help M-F 8am - 9pm ET or Sat 9am - 5:30pm.
                        </div>

                        <div className="quote-notice-text-last">
                            We look forward to taking care of your insurance needs.
                        </div>

                        <div className="row mt-10" >
                            <div className="col-sm-12 col-md-12 quote-notice-button-container">
                                <Button
                                    className="btn--primary nav-button-next mt-10  w-3/5 xs:w-full sm:w-full"
                                    children="Back To GEICO Home"
                                    onClick={handleBackToHome}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

